import { GETDITAUTHTOKEN_FAILED, GETDITAUTHTOKEN_RESPONSE } from "../types/ditUserToken"

const initialState = {
    getDITAuthToken: {}
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case GETDITAUTHTOKEN_RESPONSE:
            return { ...state, getDITAuthToken: action.payload }
        case GETDITAUTHTOKEN_FAILED:
            return { ...state, getDITAuthToken: action.payload }

        default:
            return state
    }

}
